// @flow
export const TOP_BANNERS_SIZE_CHANGED = 'TOP_BANNERS/SIZE_CHANGED';

type TopBannersSizeChangedActionType = typeof TOP_BANNERS_SIZE_CHANGED;
export type ActionType = TopBannersSizeChangedActionType;

export type Size = {
    height: number
};

export type TopBannersSizeChangedAction = {|
    type: TopBannersSizeChangedActionType,
    payload: Size
|};

export type Action = TopBannersSizeChangedAction;

const ACTION_CREATORS = {
    sizeChanged(size: Size): TopBannersSizeChangedAction {
        return {
            type: TOP_BANNERS_SIZE_CHANGED,
            payload: {
                ...size
            }
        };
    }
};

export default {
    ...ACTION_CREATORS
};
